// Verwaltung der API-Schlüssel (nur Admins). Die Berechtigung prüft das Backend.

import { jsonFetch } from './llmApi';

export const getAdminMe = (instance) => jsonFetch(instance, '/api/admin/me');

export const listApiKeys = (instance) => jsonFetch(instance, '/api/admin/api-keys');

export const createApiKey = (instance, payload) =>
  jsonFetch(instance, '/api/admin/api-keys', { method: 'POST', body: payload });

export const revokeApiKey = (instance, id) =>
  jsonFetch(instance, `/api/admin/api-keys/${id}/revoke`, { method: 'POST' });
